/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalRouteRouteImport } from './routes/_portal/route'
import { Route as Building_overviewRouteRouteImport } from './routes/building_overview/route'
import { Route as FoodLoginRouteImport } from './routes/food-login'
import { Route as PortalIndexRouteImport } from './routes/_portal/index'
import { Route as Portal401RouteImport } from './routes/_portal/401'
import { Route as Portal404RouteImport } from './routes/_portal/404'
import { Route as PortalAccessRouteImport } from './routes/_portal/access'
import { Route as PortalHandbookRouteImport } from './routes/_portal/handbook'
import { Route as PortalLunchRouteImport } from './routes/_portal/lunch'
import { Route as PortalBookingsIndexRouteImport } from './routes/_portal/bookings/index'
import { Route as PortalBookingsHistoryRouteImport } from './routes/_portal/bookings/history'
import { Route as PortalBuildingAccessRouteImport } from './routes/_portal/building/access'
import { Route as PortalBuildingAccessRoleManagementRouteImport } from './routes/_portal/building/access-role-management'
import { Route as PortalContactBuildingIdRouteImport } from './routes/_portal/contact/$buildingId'
import { Route as PortalDashboardIndexRouteImport } from './routes/_portal/dashboard/index'
import { Route as PortalFoodAdminSettingsRouteImport } from './routes/_portal/food-admin/settings'
import { Route as PortalNewsIndexRouteImport } from './routes/_portal/news/index'
import { Route as PortalNewsArticleIdRouteImport } from './routes/_portal/news/$articleId'
import { Route as PortalOrdersIndexRouteImport } from './routes/_portal/orders/index'
import { Route as PortalOrdersOrderIdRouteImport } from './routes/_portal/orders/$orderId'
import { Route as PortalOrdersNewRouteImport } from './routes/_portal/orders/new'
import { Route as PortalSettingsIndexRouteImport } from './routes/_portal/settings/index'
import { Route as PortalVisitorsIndexRouteImport } from './routes/_portal/visitors/index'
import { Route as PortalVisitorsPreregistrationRouteImport } from './routes/_portal/visitors/preregistration'
import { Route as PortalBookingsRoomRoomIdRouteImport } from './routes/_portal/bookings/room.$roomId'
import { Route as PortalBuildingBookingsIndexRouteImport } from './routes/_portal/building/bookings/index'
import { Route as PortalBuildingBookingsNewRouteImport } from './routes/_portal/building/bookings/new'
import { Route as PortalBuildingCommunicationIndexRouteImport } from './routes/_portal/building/communication/index'
import { Route as PortalBuildingCommunicationNewArticleRouteImport } from './routes/_portal/building/communication/new-article'
import { Route as PortalBuildingCompaniesIndexRouteImport } from './routes/_portal/building/companies/index'
import { Route as PortalBuildingCompaniesCompanyIdRouteImport } from './routes/_portal/building/companies/$companyId'
import { Route as PortalBuildingSettingsIndexRouteImport } from './routes/_portal/building/settings/index'
import { Route as PortalBuildingSettingsAccessRouteImport } from './routes/_portal/building/settings/access'
import { Route as PortalBuildingSettingsBookingRouteImport } from './routes/_portal/building/settings/booking'
import { Route as PortalBuildingSettingsCommunicationRouteImport } from './routes/_portal/building/settings/communication'
import { Route as PortalBuildingSettingsComplianceRouteImport } from './routes/_portal/building/settings/compliance'
import { Route as PortalBuildingSettingsFoodRouteImport } from './routes/_portal/building/settings/food'
import { Route as PortalBuildingSettingsVisitRouteImport } from './routes/_portal/building/settings/visit'
import { Route as PortalBuildingSupersettingsIndexRouteImport } from './routes/_portal/building/supersettings/index'
import { Route as PortalBuildingSupersettingsCardMigrationRouteImport } from './routes/_portal/building/supersettings/card-migration'
import { Route as PortalBuildingVisitorsIndexRouteImport } from './routes/_portal/building/visitors/index'
import { Route as PortalCompanyCompanyIdSettingsRouteImport } from './routes/_portal/company/$companyId/settings'
import { Route as PortalCompanyCompanyIdSubdivisionsRouteImport } from './routes/_portal/company/$companyId/subdivisions'
import { Route as PortalLunchAdminDealsIndexRouteImport } from './routes/_portal/lunch-admin/deals/index'
import { Route as PortalLunchAdminDealsCompanyIdRouteImport } from './routes/_portal/lunch-admin/deals/$companyId'
import { Route as PortalLunchAdminInsightsIndexRouteImport } from './routes/_portal/lunch-admin/insights/index'
import { Route as PortalLunchAdminOverviewIndexRouteImport } from './routes/_portal/lunch-admin/overview/index'
import { Route as PortalSettingsConsentsIndexRouteImport } from './routes/_portal/settings/consents/index'
import { Route as PortalSnackAdminMenuIndexRouteImport } from './routes/_portal/snack-admin/menu/index'
import { Route as PortalSnackAdminMenuCategoriesRouteImport } from './routes/_portal/snack-admin/menu/categories'
import { Route as PortalSnackAdminOrdersIndexRouteImport } from './routes/_portal/snack-admin/orders/index'
import { Route as PortalSnackAdminOrdersOrderIdRouteImport } from './routes/_portal/snack-admin/orders/$orderId'
import { Route as PortalSnackAdminOrdersNewRouteImport } from './routes/_portal/snack-admin/orders/new'
import { Route as PortalBuildingCommunicationArticleIdIndexRouteImport } from './routes/_portal/building/communication/$articleId/index'
import { Route as PortalBuildingCommunicationArticleIdEditRouteImport } from './routes/_portal/building/communication/$articleId/edit'
import { Route as PortalBuildingCommunicationNewNotificationArticleIdRouteImport } from './routes/_portal/building/communication/new-notification.$articleId'
import { Route as PortalBuildingSettingsRoomCreateRouteImport } from './routes/_portal/building/settings/room/create'
import { Route as PortalBuildingSettingsTemplateTemplateIdRouteImport } from './routes/_portal/building/settings/template/$templateId'
import { Route as PortalBuildingSettingsTemplateCreateRouteImport } from './routes/_portal/building/settings/template/create'
import { Route as PortalBuildingVisitorsPreregistrationsIndexRouteImport } from './routes/_portal/building/visitors/preregistrations/index'
import { Route as PortalBuildingVisitorsPreregistrationsNewRouteImport } from './routes/_portal/building/visitors/preregistrations/new'
import { Route as PortalCompanyCompanyIdBookingsIndexRouteImport } from './routes/_portal/company/$companyId/bookings/index'
import { Route as PortalCompanyCompanyIdBookingsNewRouteImport } from './routes/_portal/company/$companyId/bookings/new'
import { Route as PortalCompanyCompanyIdUsersIndexRouteImport } from './routes/_portal/company/$companyId/users/index'
import { Route as PortalCompanyCompanyIdUsersUserIdRouteImport } from './routes/_portal/company/$companyId/users/$userId'
import { Route as PortalCompanyCompanyIdVisitorsIndexRouteImport } from './routes/_portal/company/$companyId/visitors/index'
import { Route as PortalLunchAdminOverviewUsersIndexRouteImport } from './routes/_portal/lunch-admin/overview/users/index'
import { Route as PortalLunchAdminOverviewUsersUserIdRouteImport } from './routes/_portal/lunch-admin/overview/users/$userId'
import { Route as PortalSnackAdminMenuItemItemIdRouteImport } from './routes/_portal/snack-admin/menu/item/$itemId'
import { Route as PortalSnackAdminMenuItemNewRouteImport } from './routes/_portal/snack-admin/menu/item/new'
import { Route as PortalBuildingSettingsRoomRoomIdEditRouteImport } from './routes/_portal/building/settings/room/$roomId.edit'
import { Route as PortalCompanyCompanyIdUsersUserIdAccessRouteImport } from './routes/_portal/company/$companyId/users/$userId.access'
import { Route as PortalCompanyCompanyIdUsersUserIdFoodRouteImport } from './routes/_portal/company/$companyId/users/$userId.food'
import { Route as PortalCompanyCompanyIdUsersUserIdSettingsRouteImport } from './routes/_portal/company/$companyId/users/$userId.settings'
import { Route as PortalCompanyCompanyIdVisitorsPreregistrationsIndexRouteImport } from './routes/_portal/company/$companyId/visitors/preregistrations/index'
import { Route as PortalCompanyCompanyIdVisitorsPreregistrationsNewRouteImport } from './routes/_portal/company/$companyId/visitors/preregistrations/new'

const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/_portal',
  getParentRoute: () => rootRouteImport,
} as any)
const Building_overviewRouteRoute = Building_overviewRouteRouteImport.update({
  id: '/building_overview',
  path: '/building_overview',
  getParentRoute: () => rootRouteImport,
} as any)
const FoodLoginRoute = FoodLoginRouteImport.update({
  id: '/food-login',
  path: '/food-login',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const Portal401Route = Portal401RouteImport.update({
  id: '/401',
  path: '/401',
  getParentRoute: () => PortalRouteRoute,
} as any)
const Portal404Route = Portal404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalAccessRoute = PortalAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalHandbookRoute = PortalHandbookRouteImport.update({
  id: '/handbook',
  path: '/handbook',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalLunchRoute = PortalLunchRouteImport.update({
  id: '/lunch',
  path: '/lunch',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalBookingsIndexRoute = PortalBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalBookingsHistoryRoute = PortalBookingsHistoryRouteImport.update({
  id: '/bookings/history',
  path: '/bookings/history',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalBuildingAccessRoute = PortalBuildingAccessRouteImport.update({
  id: '/building/access',
  path: '/building/access',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalBuildingAccessRoleManagementRoute =
  PortalBuildingAccessRoleManagementRouteImport.update({
    id: '/building/access-role-management',
    path: '/building/access-role-management',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalContactBuildingIdRoute = PortalContactBuildingIdRouteImport.update({
  id: '/contact/$buildingId',
  path: '/contact/$buildingId',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDashboardIndexRoute = PortalDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalFoodAdminSettingsRoute = PortalFoodAdminSettingsRouteImport.update({
  id: '/food-admin/settings',
  path: '/food-admin/settings',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalNewsIndexRoute = PortalNewsIndexRouteImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalNewsArticleIdRoute = PortalNewsArticleIdRouteImport.update({
  id: '/news/$articleId',
  path: '/news/$articleId',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalOrdersIndexRoute = PortalOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalOrdersOrderIdRoute = PortalOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalOrdersNewRoute = PortalOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalSettingsIndexRoute = PortalSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalVisitorsIndexRoute = PortalVisitorsIndexRouteImport.update({
  id: '/visitors/',
  path: '/visitors/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalVisitorsPreregistrationRoute =
  PortalVisitorsPreregistrationRouteImport.update({
    id: '/visitors/preregistration',
    path: '/visitors/preregistration',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBookingsRoomRoomIdRoute =
  PortalBookingsRoomRoomIdRouteImport.update({
    id: '/bookings/room/$roomId',
    path: '/bookings/room/$roomId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingBookingsIndexRoute =
  PortalBuildingBookingsIndexRouteImport.update({
    id: '/building/bookings/',
    path: '/building/bookings/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingBookingsNewRoute =
  PortalBuildingBookingsNewRouteImport.update({
    id: '/building/bookings/new',
    path: '/building/bookings/new',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCommunicationIndexRoute =
  PortalBuildingCommunicationIndexRouteImport.update({
    id: '/building/communication/',
    path: '/building/communication/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCommunicationNewArticleRoute =
  PortalBuildingCommunicationNewArticleRouteImport.update({
    id: '/building/communication/new-article',
    path: '/building/communication/new-article',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCompaniesIndexRoute =
  PortalBuildingCompaniesIndexRouteImport.update({
    id: '/building/companies/',
    path: '/building/companies/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCompaniesCompanyIdRoute =
  PortalBuildingCompaniesCompanyIdRouteImport.update({
    id: '/building/companies/$companyId',
    path: '/building/companies/$companyId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsIndexRoute =
  PortalBuildingSettingsIndexRouteImport.update({
    id: '/building/settings/',
    path: '/building/settings/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsAccessRoute =
  PortalBuildingSettingsAccessRouteImport.update({
    id: '/building/settings/access',
    path: '/building/settings/access',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsBookingRoute =
  PortalBuildingSettingsBookingRouteImport.update({
    id: '/building/settings/booking',
    path: '/building/settings/booking',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsCommunicationRoute =
  PortalBuildingSettingsCommunicationRouteImport.update({
    id: '/building/settings/communication',
    path: '/building/settings/communication',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsComplianceRoute =
  PortalBuildingSettingsComplianceRouteImport.update({
    id: '/building/settings/compliance',
    path: '/building/settings/compliance',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsFoodRoute =
  PortalBuildingSettingsFoodRouteImport.update({
    id: '/building/settings/food',
    path: '/building/settings/food',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsVisitRoute =
  PortalBuildingSettingsVisitRouteImport.update({
    id: '/building/settings/visit',
    path: '/building/settings/visit',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSupersettingsIndexRoute =
  PortalBuildingSupersettingsIndexRouteImport.update({
    id: '/building/supersettings/',
    path: '/building/supersettings/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSupersettingsCardMigrationRoute =
  PortalBuildingSupersettingsCardMigrationRouteImport.update({
    id: '/building/supersettings/card-migration',
    path: '/building/supersettings/card-migration',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingVisitorsIndexRoute =
  PortalBuildingVisitorsIndexRouteImport.update({
    id: '/building/visitors/',
    path: '/building/visitors/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdSettingsRoute =
  PortalCompanyCompanyIdSettingsRouteImport.update({
    id: '/company/$companyId/settings',
    path: '/company/$companyId/settings',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdSubdivisionsRoute =
  PortalCompanyCompanyIdSubdivisionsRouteImport.update({
    id: '/company/$companyId/subdivisions',
    path: '/company/$companyId/subdivisions',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalLunchAdminDealsIndexRoute =
  PortalLunchAdminDealsIndexRouteImport.update({
    id: '/lunch-admin/deals/',
    path: '/lunch-admin/deals/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalLunchAdminDealsCompanyIdRoute =
  PortalLunchAdminDealsCompanyIdRouteImport.update({
    id: '/lunch-admin/deals/$companyId',
    path: '/lunch-admin/deals/$companyId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalLunchAdminInsightsIndexRoute =
  PortalLunchAdminInsightsIndexRouteImport.update({
    id: '/lunch-admin/insights/',
    path: '/lunch-admin/insights/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalLunchAdminOverviewIndexRoute =
  PortalLunchAdminOverviewIndexRouteImport.update({
    id: '/lunch-admin/overview/',
    path: '/lunch-admin/overview/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSettingsConsentsIndexRoute =
  PortalSettingsConsentsIndexRouteImport.update({
    id: '/settings/consents/',
    path: '/settings/consents/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminMenuIndexRoute =
  PortalSnackAdminMenuIndexRouteImport.update({
    id: '/snack-admin/menu/',
    path: '/snack-admin/menu/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminMenuCategoriesRoute =
  PortalSnackAdminMenuCategoriesRouteImport.update({
    id: '/snack-admin/menu/categories',
    path: '/snack-admin/menu/categories',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminOrdersIndexRoute =
  PortalSnackAdminOrdersIndexRouteImport.update({
    id: '/snack-admin/orders/',
    path: '/snack-admin/orders/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminOrdersOrderIdRoute =
  PortalSnackAdminOrdersOrderIdRouteImport.update({
    id: '/snack-admin/orders/$orderId',
    path: '/snack-admin/orders/$orderId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminOrdersNewRoute =
  PortalSnackAdminOrdersNewRouteImport.update({
    id: '/snack-admin/orders/new',
    path: '/snack-admin/orders/new',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCommunicationArticleIdIndexRoute =
  PortalBuildingCommunicationArticleIdIndexRouteImport.update({
    id: '/building/communication/$articleId/',
    path: '/building/communication/$articleId/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCommunicationArticleIdEditRoute =
  PortalBuildingCommunicationArticleIdEditRouteImport.update({
    id: '/building/communication/$articleId/edit',
    path: '/building/communication/$articleId/edit',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingCommunicationNewNotificationArticleIdRoute =
  PortalBuildingCommunicationNewNotificationArticleIdRouteImport.update({
    id: '/building/communication/new-notification/$articleId',
    path: '/building/communication/new-notification/$articleId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsRoomCreateRoute =
  PortalBuildingSettingsRoomCreateRouteImport.update({
    id: '/building/settings/room/create',
    path: '/building/settings/room/create',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsTemplateTemplateIdRoute =
  PortalBuildingSettingsTemplateTemplateIdRouteImport.update({
    id: '/building/settings/template/$templateId',
    path: '/building/settings/template/$templateId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsTemplateCreateRoute =
  PortalBuildingSettingsTemplateCreateRouteImport.update({
    id: '/building/settings/template/create',
    path: '/building/settings/template/create',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingVisitorsPreregistrationsIndexRoute =
  PortalBuildingVisitorsPreregistrationsIndexRouteImport.update({
    id: '/building/visitors/preregistrations/',
    path: '/building/visitors/preregistrations/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingVisitorsPreregistrationsNewRoute =
  PortalBuildingVisitorsPreregistrationsNewRouteImport.update({
    id: '/building/visitors/preregistrations/new',
    path: '/building/visitors/preregistrations/new',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdBookingsIndexRoute =
  PortalCompanyCompanyIdBookingsIndexRouteImport.update({
    id: '/company/$companyId/bookings/',
    path: '/company/$companyId/bookings/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdBookingsNewRoute =
  PortalCompanyCompanyIdBookingsNewRouteImport.update({
    id: '/company/$companyId/bookings/new',
    path: '/company/$companyId/bookings/new',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdUsersIndexRoute =
  PortalCompanyCompanyIdUsersIndexRouteImport.update({
    id: '/company/$companyId/users/',
    path: '/company/$companyId/users/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdUsersUserIdRoute =
  PortalCompanyCompanyIdUsersUserIdRouteImport.update({
    id: '/company/$companyId/users/$userId',
    path: '/company/$companyId/users/$userId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdVisitorsIndexRoute =
  PortalCompanyCompanyIdVisitorsIndexRouteImport.update({
    id: '/company/$companyId/visitors/',
    path: '/company/$companyId/visitors/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalLunchAdminOverviewUsersIndexRoute =
  PortalLunchAdminOverviewUsersIndexRouteImport.update({
    id: '/lunch-admin/overview/users/',
    path: '/lunch-admin/overview/users/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalLunchAdminOverviewUsersUserIdRoute =
  PortalLunchAdminOverviewUsersUserIdRouteImport.update({
    id: '/lunch-admin/overview/users/$userId',
    path: '/lunch-admin/overview/users/$userId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminMenuItemItemIdRoute =
  PortalSnackAdminMenuItemItemIdRouteImport.update({
    id: '/snack-admin/menu/item/$itemId',
    path: '/snack-admin/menu/item/$itemId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalSnackAdminMenuItemNewRoute =
  PortalSnackAdminMenuItemNewRouteImport.update({
    id: '/snack-admin/menu/item/new',
    path: '/snack-admin/menu/item/new',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalBuildingSettingsRoomRoomIdEditRoute =
  PortalBuildingSettingsRoomRoomIdEditRouteImport.update({
    id: '/building/settings/room/$roomId/edit',
    path: '/building/settings/room/$roomId/edit',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdUsersUserIdAccessRoute =
  PortalCompanyCompanyIdUsersUserIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => PortalCompanyCompanyIdUsersUserIdRoute,
  } as any)
const PortalCompanyCompanyIdUsersUserIdFoodRoute =
  PortalCompanyCompanyIdUsersUserIdFoodRouteImport.update({
    id: '/food',
    path: '/food',
    getParentRoute: () => PortalCompanyCompanyIdUsersUserIdRoute,
  } as any)
const PortalCompanyCompanyIdUsersUserIdSettingsRoute =
  PortalCompanyCompanyIdUsersUserIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => PortalCompanyCompanyIdUsersUserIdRoute,
  } as any)
const PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute =
  PortalCompanyCompanyIdVisitorsPreregistrationsIndexRouteImport.update({
    id: '/company/$companyId/visitors/preregistrations/',
    path: '/company/$companyId/visitors/preregistrations/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute =
  PortalCompanyCompanyIdVisitorsPreregistrationsNewRouteImport.update({
    id: '/company/$companyId/visitors/preregistrations/new',
    path: '/company/$companyId/visitors/preregistrations/new',
    getParentRoute: () => PortalRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PortalIndexRoute
  '/building_overview': typeof Building_overviewRouteRoute
  '/food-login': typeof FoodLoginRoute
  '/401': typeof Portal401Route
  '/404': typeof Portal404Route
  '/access': typeof PortalAccessRoute
  '/handbook': typeof PortalHandbookRoute
  '/lunch': typeof PortalLunchRoute
  '/bookings/history': typeof PortalBookingsHistoryRoute
  '/building/access': typeof PortalBuildingAccessRoute
  '/building/access-role-management': typeof PortalBuildingAccessRoleManagementRoute
  '/contact/$buildingId': typeof PortalContactBuildingIdRoute
  '/food-admin/settings': typeof PortalFoodAdminSettingsRoute
  '/news/$articleId': typeof PortalNewsArticleIdRoute
  '/orders/$orderId': typeof PortalOrdersOrderIdRoute
  '/orders/new': typeof PortalOrdersNewRoute
  '/visitors/preregistration': typeof PortalVisitorsPreregistrationRoute
  '/bookings/': typeof PortalBookingsIndexRoute
  '/dashboard/': typeof PortalDashboardIndexRoute
  '/news/': typeof PortalNewsIndexRoute
  '/orders/': typeof PortalOrdersIndexRoute
  '/settings/': typeof PortalSettingsIndexRoute
  '/visitors/': typeof PortalVisitorsIndexRoute
  '/bookings/room/$roomId': typeof PortalBookingsRoomRoomIdRoute
  '/building/bookings/new': typeof PortalBuildingBookingsNewRoute
  '/building/communication/new-article': typeof PortalBuildingCommunicationNewArticleRoute
  '/building/companies/$companyId': typeof PortalBuildingCompaniesCompanyIdRoute
  '/building/settings/access': typeof PortalBuildingSettingsAccessRoute
  '/building/settings/booking': typeof PortalBuildingSettingsBookingRoute
  '/building/settings/communication': typeof PortalBuildingSettingsCommunicationRoute
  '/building/settings/compliance': typeof PortalBuildingSettingsComplianceRoute
  '/building/settings/food': typeof PortalBuildingSettingsFoodRoute
  '/building/settings/visit': typeof PortalBuildingSettingsVisitRoute
  '/building/supersettings/card-migration': typeof PortalBuildingSupersettingsCardMigrationRoute
  '/company/$companyId/settings': typeof PortalCompanyCompanyIdSettingsRoute
  '/company/$companyId/subdivisions': typeof PortalCompanyCompanyIdSubdivisionsRoute
  '/lunch-admin/deals/$companyId': typeof PortalLunchAdminDealsCompanyIdRoute
  '/snack-admin/menu/categories': typeof PortalSnackAdminMenuCategoriesRoute
  '/snack-admin/orders/$orderId': typeof PortalSnackAdminOrdersOrderIdRoute
  '/snack-admin/orders/new': typeof PortalSnackAdminOrdersNewRoute
  '/building/bookings/': typeof PortalBuildingBookingsIndexRoute
  '/building/communication/': typeof PortalBuildingCommunicationIndexRoute
  '/building/companies/': typeof PortalBuildingCompaniesIndexRoute
  '/building/settings/': typeof PortalBuildingSettingsIndexRoute
  '/building/supersettings/': typeof PortalBuildingSupersettingsIndexRoute
  '/building/visitors/': typeof PortalBuildingVisitorsIndexRoute
  '/lunch-admin/deals/': typeof PortalLunchAdminDealsIndexRoute
  '/lunch-admin/insights/': typeof PortalLunchAdminInsightsIndexRoute
  '/lunch-admin/overview/': typeof PortalLunchAdminOverviewIndexRoute
  '/settings/consents/': typeof PortalSettingsConsentsIndexRoute
  '/snack-admin/menu/': typeof PortalSnackAdminMenuIndexRoute
  '/snack-admin/orders/': typeof PortalSnackAdminOrdersIndexRoute
  '/building/communication/$articleId/edit': typeof PortalBuildingCommunicationArticleIdEditRoute
  '/building/communication/new-notification/$articleId': typeof PortalBuildingCommunicationNewNotificationArticleIdRoute
  '/building/settings/room/create': typeof PortalBuildingSettingsRoomCreateRoute
  '/building/settings/template/$templateId': typeof PortalBuildingSettingsTemplateTemplateIdRoute
  '/building/settings/template/create': typeof PortalBuildingSettingsTemplateCreateRoute
  '/building/visitors/preregistrations/new': typeof PortalBuildingVisitorsPreregistrationsNewRoute
  '/company/$companyId/bookings/new': typeof PortalCompanyCompanyIdBookingsNewRoute
  '/company/$companyId/users/$userId': typeof PortalCompanyCompanyIdUsersUserIdRouteWithChildren
  '/lunch-admin/overview/users/$userId': typeof PortalLunchAdminOverviewUsersUserIdRoute
  '/snack-admin/menu/item/$itemId': typeof PortalSnackAdminMenuItemItemIdRoute
  '/snack-admin/menu/item/new': typeof PortalSnackAdminMenuItemNewRoute
  '/building/communication/$articleId/': typeof PortalBuildingCommunicationArticleIdIndexRoute
  '/building/visitors/preregistrations/': typeof PortalBuildingVisitorsPreregistrationsIndexRoute
  '/company/$companyId/bookings/': typeof PortalCompanyCompanyIdBookingsIndexRoute
  '/company/$companyId/users/': typeof PortalCompanyCompanyIdUsersIndexRoute
  '/company/$companyId/visitors/': typeof PortalCompanyCompanyIdVisitorsIndexRoute
  '/lunch-admin/overview/users/': typeof PortalLunchAdminOverviewUsersIndexRoute
  '/building/settings/room/$roomId/edit': typeof PortalBuildingSettingsRoomRoomIdEditRoute
  '/company/$companyId/users/$userId/access': typeof PortalCompanyCompanyIdUsersUserIdAccessRoute
  '/company/$companyId/users/$userId/food': typeof PortalCompanyCompanyIdUsersUserIdFoodRoute
  '/company/$companyId/users/$userId/settings': typeof PortalCompanyCompanyIdUsersUserIdSettingsRoute
  '/company/$companyId/visitors/preregistrations/new': typeof PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute
  '/company/$companyId/visitors/preregistrations/': typeof PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute
}
export interface FileRoutesByTo {
  '/building_overview': typeof Building_overviewRouteRoute
  '/food-login': typeof FoodLoginRoute
  '/401': typeof Portal401Route
  '/404': typeof Portal404Route
  '/access': typeof PortalAccessRoute
  '/handbook': typeof PortalHandbookRoute
  '/lunch': typeof PortalLunchRoute
  '/': typeof PortalIndexRoute
  '/bookings/history': typeof PortalBookingsHistoryRoute
  '/building/access': typeof PortalBuildingAccessRoute
  '/building/access-role-management': typeof PortalBuildingAccessRoleManagementRoute
  '/contact/$buildingId': typeof PortalContactBuildingIdRoute
  '/food-admin/settings': typeof PortalFoodAdminSettingsRoute
  '/news/$articleId': typeof PortalNewsArticleIdRoute
  '/orders/$orderId': typeof PortalOrdersOrderIdRoute
  '/orders/new': typeof PortalOrdersNewRoute
  '/visitors/preregistration': typeof PortalVisitorsPreregistrationRoute
  '/bookings': typeof PortalBookingsIndexRoute
  '/dashboard': typeof PortalDashboardIndexRoute
  '/news': typeof PortalNewsIndexRoute
  '/orders': typeof PortalOrdersIndexRoute
  '/settings': typeof PortalSettingsIndexRoute
  '/visitors': typeof PortalVisitorsIndexRoute
  '/bookings/room/$roomId': typeof PortalBookingsRoomRoomIdRoute
  '/building/bookings/new': typeof PortalBuildingBookingsNewRoute
  '/building/communication/new-article': typeof PortalBuildingCommunicationNewArticleRoute
  '/building/companies/$companyId': typeof PortalBuildingCompaniesCompanyIdRoute
  '/building/settings/access': typeof PortalBuildingSettingsAccessRoute
  '/building/settings/booking': typeof PortalBuildingSettingsBookingRoute
  '/building/settings/communication': typeof PortalBuildingSettingsCommunicationRoute
  '/building/settings/compliance': typeof PortalBuildingSettingsComplianceRoute
  '/building/settings/food': typeof PortalBuildingSettingsFoodRoute
  '/building/settings/visit': typeof PortalBuildingSettingsVisitRoute
  '/building/supersettings/card-migration': typeof PortalBuildingSupersettingsCardMigrationRoute
  '/company/$companyId/settings': typeof PortalCompanyCompanyIdSettingsRoute
  '/company/$companyId/subdivisions': typeof PortalCompanyCompanyIdSubdivisionsRoute
  '/lunch-admin/deals/$companyId': typeof PortalLunchAdminDealsCompanyIdRoute
  '/snack-admin/menu/categories': typeof PortalSnackAdminMenuCategoriesRoute
  '/snack-admin/orders/$orderId': typeof PortalSnackAdminOrdersOrderIdRoute
  '/snack-admin/orders/new': typeof PortalSnackAdminOrdersNewRoute
  '/building/bookings': typeof PortalBuildingBookingsIndexRoute
  '/building/communication': typeof PortalBuildingCommunicationIndexRoute
  '/building/companies': typeof PortalBuildingCompaniesIndexRoute
  '/building/settings': typeof PortalBuildingSettingsIndexRoute
  '/building/supersettings': typeof PortalBuildingSupersettingsIndexRoute
  '/building/visitors': typeof PortalBuildingVisitorsIndexRoute
  '/lunch-admin/deals': typeof PortalLunchAdminDealsIndexRoute
  '/lunch-admin/insights': typeof PortalLunchAdminInsightsIndexRoute
  '/lunch-admin/overview': typeof PortalLunchAdminOverviewIndexRoute
  '/settings/consents': typeof PortalSettingsConsentsIndexRoute
  '/snack-admin/menu': typeof PortalSnackAdminMenuIndexRoute
  '/snack-admin/orders': typeof PortalSnackAdminOrdersIndexRoute
  '/building/communication/$articleId/edit': typeof PortalBuildingCommunicationArticleIdEditRoute
  '/building/communication/new-notification/$articleId': typeof PortalBuildingCommunicationNewNotificationArticleIdRoute
  '/building/settings/room/create': typeof PortalBuildingSettingsRoomCreateRoute
  '/building/settings/template/$templateId': typeof PortalBuildingSettingsTemplateTemplateIdRoute
  '/building/settings/template/create': typeof PortalBuildingSettingsTemplateCreateRoute
  '/building/visitors/preregistrations/new': typeof PortalBuildingVisitorsPreregistrationsNewRoute
  '/company/$companyId/bookings/new': typeof PortalCompanyCompanyIdBookingsNewRoute
  '/company/$companyId/users/$userId': typeof PortalCompanyCompanyIdUsersUserIdRouteWithChildren
  '/lunch-admin/overview/users/$userId': typeof PortalLunchAdminOverviewUsersUserIdRoute
  '/snack-admin/menu/item/$itemId': typeof PortalSnackAdminMenuItemItemIdRoute
  '/snack-admin/menu/item/new': typeof PortalSnackAdminMenuItemNewRoute
  '/building/communication/$articleId': typeof PortalBuildingCommunicationArticleIdIndexRoute
  '/building/visitors/preregistrations': typeof PortalBuildingVisitorsPreregistrationsIndexRoute
  '/company/$companyId/bookings': typeof PortalCompanyCompanyIdBookingsIndexRoute
  '/company/$companyId/users': typeof PortalCompanyCompanyIdUsersIndexRoute
  '/company/$companyId/visitors': typeof PortalCompanyCompanyIdVisitorsIndexRoute
  '/lunch-admin/overview/users': typeof PortalLunchAdminOverviewUsersIndexRoute
  '/building/settings/room/$roomId/edit': typeof PortalBuildingSettingsRoomRoomIdEditRoute
  '/company/$companyId/users/$userId/access': typeof PortalCompanyCompanyIdUsersUserIdAccessRoute
  '/company/$companyId/users/$userId/food': typeof PortalCompanyCompanyIdUsersUserIdFoodRoute
  '/company/$companyId/users/$userId/settings': typeof PortalCompanyCompanyIdUsersUserIdSettingsRoute
  '/company/$companyId/visitors/preregistrations/new': typeof PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute
  '/company/$companyId/visitors/preregistrations': typeof PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_portal': typeof PortalRouteRouteWithChildren
  '/building_overview': typeof Building_overviewRouteRoute
  '/food-login': typeof FoodLoginRoute
  '/_portal/401': typeof Portal401Route
  '/_portal/404': typeof Portal404Route
  '/_portal/access': typeof PortalAccessRoute
  '/_portal/handbook': typeof PortalHandbookRoute
  '/_portal/lunch': typeof PortalLunchRoute
  '/_portal/': typeof PortalIndexRoute
  '/_portal/bookings/history': typeof PortalBookingsHistoryRoute
  '/_portal/building/access': typeof PortalBuildingAccessRoute
  '/_portal/building/access-role-management': typeof PortalBuildingAccessRoleManagementRoute
  '/_portal/contact/$buildingId': typeof PortalContactBuildingIdRoute
  '/_portal/food-admin/settings': typeof PortalFoodAdminSettingsRoute
  '/_portal/news/$articleId': typeof PortalNewsArticleIdRoute
  '/_portal/orders/$orderId': typeof PortalOrdersOrderIdRoute
  '/_portal/orders/new': typeof PortalOrdersNewRoute
  '/_portal/visitors/preregistration': typeof PortalVisitorsPreregistrationRoute
  '/_portal/bookings/': typeof PortalBookingsIndexRoute
  '/_portal/dashboard/': typeof PortalDashboardIndexRoute
  '/_portal/news/': typeof PortalNewsIndexRoute
  '/_portal/orders/': typeof PortalOrdersIndexRoute
  '/_portal/settings/': typeof PortalSettingsIndexRoute
  '/_portal/visitors/': typeof PortalVisitorsIndexRoute
  '/_portal/bookings/room/$roomId': typeof PortalBookingsRoomRoomIdRoute
  '/_portal/building/bookings/new': typeof PortalBuildingBookingsNewRoute
  '/_portal/building/communication/new-article': typeof PortalBuildingCommunicationNewArticleRoute
  '/_portal/building/companies/$companyId': typeof PortalBuildingCompaniesCompanyIdRoute
  '/_portal/building/settings/access': typeof PortalBuildingSettingsAccessRoute
  '/_portal/building/settings/booking': typeof PortalBuildingSettingsBookingRoute
  '/_portal/building/settings/communication': typeof PortalBuildingSettingsCommunicationRoute
  '/_portal/building/settings/compliance': typeof PortalBuildingSettingsComplianceRoute
  '/_portal/building/settings/food': typeof PortalBuildingSettingsFoodRoute
  '/_portal/building/settings/visit': typeof PortalBuildingSettingsVisitRoute
  '/_portal/building/supersettings/card-migration': typeof PortalBuildingSupersettingsCardMigrationRoute
  '/_portal/company/$companyId/settings': typeof PortalCompanyCompanyIdSettingsRoute
  '/_portal/company/$companyId/subdivisions': typeof PortalCompanyCompanyIdSubdivisionsRoute
  '/_portal/lunch-admin/deals/$companyId': typeof PortalLunchAdminDealsCompanyIdRoute
  '/_portal/snack-admin/menu/categories': typeof PortalSnackAdminMenuCategoriesRoute
  '/_portal/snack-admin/orders/$orderId': typeof PortalSnackAdminOrdersOrderIdRoute
  '/_portal/snack-admin/orders/new': typeof PortalSnackAdminOrdersNewRoute
  '/_portal/building/bookings/': typeof PortalBuildingBookingsIndexRoute
  '/_portal/building/communication/': typeof PortalBuildingCommunicationIndexRoute
  '/_portal/building/companies/': typeof PortalBuildingCompaniesIndexRoute
  '/_portal/building/settings/': typeof PortalBuildingSettingsIndexRoute
  '/_portal/building/supersettings/': typeof PortalBuildingSupersettingsIndexRoute
  '/_portal/building/visitors/': typeof PortalBuildingVisitorsIndexRoute
  '/_portal/lunch-admin/deals/': typeof PortalLunchAdminDealsIndexRoute
  '/_portal/lunch-admin/insights/': typeof PortalLunchAdminInsightsIndexRoute
  '/_portal/lunch-admin/overview/': typeof PortalLunchAdminOverviewIndexRoute
  '/_portal/settings/consents/': typeof PortalSettingsConsentsIndexRoute
  '/_portal/snack-admin/menu/': typeof PortalSnackAdminMenuIndexRoute
  '/_portal/snack-admin/orders/': typeof PortalSnackAdminOrdersIndexRoute
  '/_portal/building/communication/$articleId/edit': typeof PortalBuildingCommunicationArticleIdEditRoute
  '/_portal/building/communication/new-notification/$articleId': typeof PortalBuildingCommunicationNewNotificationArticleIdRoute
  '/_portal/building/settings/room/create': typeof PortalBuildingSettingsRoomCreateRoute
  '/_portal/building/settings/template/$templateId': typeof PortalBuildingSettingsTemplateTemplateIdRoute
  '/_portal/building/settings/template/create': typeof PortalBuildingSettingsTemplateCreateRoute
  '/_portal/building/visitors/preregistrations/new': typeof PortalBuildingVisitorsPreregistrationsNewRoute
  '/_portal/company/$companyId/bookings/new': typeof PortalCompanyCompanyIdBookingsNewRoute
  '/_portal/company/$companyId/users/$userId': typeof PortalCompanyCompanyIdUsersUserIdRouteWithChildren
  '/_portal/lunch-admin/overview/users/$userId': typeof PortalLunchAdminOverviewUsersUserIdRoute
  '/_portal/snack-admin/menu/item/$itemId': typeof PortalSnackAdminMenuItemItemIdRoute
  '/_portal/snack-admin/menu/item/new': typeof PortalSnackAdminMenuItemNewRoute
  '/_portal/building/communication/$articleId/': typeof PortalBuildingCommunicationArticleIdIndexRoute
  '/_portal/building/visitors/preregistrations/': typeof PortalBuildingVisitorsPreregistrationsIndexRoute
  '/_portal/company/$companyId/bookings/': typeof PortalCompanyCompanyIdBookingsIndexRoute
  '/_portal/company/$companyId/users/': typeof PortalCompanyCompanyIdUsersIndexRoute
  '/_portal/company/$companyId/visitors/': typeof PortalCompanyCompanyIdVisitorsIndexRoute
  '/_portal/lunch-admin/overview/users/': typeof PortalLunchAdminOverviewUsersIndexRoute
  '/_portal/building/settings/room/$roomId/edit': typeof PortalBuildingSettingsRoomRoomIdEditRoute
  '/_portal/company/$companyId/users/$userId/access': typeof PortalCompanyCompanyIdUsersUserIdAccessRoute
  '/_portal/company/$companyId/users/$userId/food': typeof PortalCompanyCompanyIdUsersUserIdFoodRoute
  '/_portal/company/$companyId/users/$userId/settings': typeof PortalCompanyCompanyIdUsersUserIdSettingsRoute
  '/_portal/company/$companyId/visitors/preregistrations/new': typeof PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute
  '/_portal/company/$companyId/visitors/preregistrations/': typeof PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/building_overview'
    | '/food-login'
    | '/401'
    | '/404'
    | '/access'
    | '/handbook'
    | '/lunch'
    | '/bookings/history'
    | '/building/access'
    | '/building/access-role-management'
    | '/contact/$buildingId'
    | '/food-admin/settings'
    | '/news/$articleId'
    | '/orders/$orderId'
    | '/orders/new'
    | '/visitors/preregistration'
    | '/bookings/'
    | '/dashboard/'
    | '/news/'
    | '/orders/'
    | '/settings/'
    | '/visitors/'
    | '/bookings/room/$roomId'
    | '/building/bookings/new'
    | '/building/communication/new-article'
    | '/building/companies/$companyId'
    | '/building/settings/access'
    | '/building/settings/booking'
    | '/building/settings/communication'
    | '/building/settings/compliance'
    | '/building/settings/food'
    | '/building/settings/visit'
    | '/building/supersettings/card-migration'
    | '/company/$companyId/settings'
    | '/company/$companyId/subdivisions'
    | '/lunch-admin/deals/$companyId'
    | '/snack-admin/menu/categories'
    | '/snack-admin/orders/$orderId'
    | '/snack-admin/orders/new'
    | '/building/bookings/'
    | '/building/communication/'
    | '/building/companies/'
    | '/building/settings/'
    | '/building/supersettings/'
    | '/building/visitors/'
    | '/lunch-admin/deals/'
    | '/lunch-admin/insights/'
    | '/lunch-admin/overview/'
    | '/settings/consents/'
    | '/snack-admin/menu/'
    | '/snack-admin/orders/'
    | '/building/communication/$articleId/edit'
    | '/building/communication/new-notification/$articleId'
    | '/building/settings/room/create'
    | '/building/settings/template/$templateId'
    | '/building/settings/template/create'
    | '/building/visitors/preregistrations/new'
    | '/company/$companyId/bookings/new'
    | '/company/$companyId/users/$userId'
    | '/lunch-admin/overview/users/$userId'
    | '/snack-admin/menu/item/$itemId'
    | '/snack-admin/menu/item/new'
    | '/building/communication/$articleId/'
    | '/building/visitors/preregistrations/'
    | '/company/$companyId/bookings/'
    | '/company/$companyId/users/'
    | '/company/$companyId/visitors/'
    | '/lunch-admin/overview/users/'
    | '/building/settings/room/$roomId/edit'
    | '/company/$companyId/users/$userId/access'
    | '/company/$companyId/users/$userId/food'
    | '/company/$companyId/users/$userId/settings'
    | '/company/$companyId/visitors/preregistrations/new'
    | '/company/$companyId/visitors/preregistrations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/building_overview'
    | '/food-login'
    | '/401'
    | '/404'
    | '/access'
    | '/handbook'
    | '/lunch'
    | '/'
    | '/bookings/history'
    | '/building/access'
    | '/building/access-role-management'
    | '/contact/$buildingId'
    | '/food-admin/settings'
    | '/news/$articleId'
    | '/orders/$orderId'
    | '/orders/new'
    | '/visitors/preregistration'
    | '/bookings'
    | '/dashboard'
    | '/news'
    | '/orders'
    | '/settings'
    | '/visitors'
    | '/bookings/room/$roomId'
    | '/building/bookings/new'
    | '/building/communication/new-article'
    | '/building/companies/$companyId'
    | '/building/settings/access'
    | '/building/settings/booking'
    | '/building/settings/communication'
    | '/building/settings/compliance'
    | '/building/settings/food'
    | '/building/settings/visit'
    | '/building/supersettings/card-migration'
    | '/company/$companyId/settings'
    | '/company/$companyId/subdivisions'
    | '/lunch-admin/deals/$companyId'
    | '/snack-admin/menu/categories'
    | '/snack-admin/orders/$orderId'
    | '/snack-admin/orders/new'
    | '/building/bookings'
    | '/building/communication'
    | '/building/companies'
    | '/building/settings'
    | '/building/supersettings'
    | '/building/visitors'
    | '/lunch-admin/deals'
    | '/lunch-admin/insights'
    | '/lunch-admin/overview'
    | '/settings/consents'
    | '/snack-admin/menu'
    | '/snack-admin/orders'
    | '/building/communication/$articleId/edit'
    | '/building/communication/new-notification/$articleId'
    | '/building/settings/room/create'
    | '/building/settings/template/$templateId'
    | '/building/settings/template/create'
    | '/building/visitors/preregistrations/new'
    | '/company/$companyId/bookings/new'
    | '/company/$companyId/users/$userId'
    | '/lunch-admin/overview/users/$userId'
    | '/snack-admin/menu/item/$itemId'
    | '/snack-admin/menu/item/new'
    | '/building/communication/$articleId'
    | '/building/visitors/preregistrations'
    | '/company/$companyId/bookings'
    | '/company/$companyId/users'
    | '/company/$companyId/visitors'
    | '/lunch-admin/overview/users'
    | '/building/settings/room/$roomId/edit'
    | '/company/$companyId/users/$userId/access'
    | '/company/$companyId/users/$userId/food'
    | '/company/$companyId/users/$userId/settings'
    | '/company/$companyId/visitors/preregistrations/new'
    | '/company/$companyId/visitors/preregistrations'
  id:
    | '__root__'
    | '/_portal'
    | '/building_overview'
    | '/food-login'
    | '/_portal/401'
    | '/_portal/404'
    | '/_portal/access'
    | '/_portal/handbook'
    | '/_portal/lunch'
    | '/_portal/'
    | '/_portal/bookings/history'
    | '/_portal/building/access'
    | '/_portal/building/access-role-management'
    | '/_portal/contact/$buildingId'
    | '/_portal/food-admin/settings'
    | '/_portal/news/$articleId'
    | '/_portal/orders/$orderId'
    | '/_portal/orders/new'
    | '/_portal/visitors/preregistration'
    | '/_portal/bookings/'
    | '/_portal/dashboard/'
    | '/_portal/news/'
    | '/_portal/orders/'
    | '/_portal/settings/'
    | '/_portal/visitors/'
    | '/_portal/bookings/room/$roomId'
    | '/_portal/building/bookings/new'
    | '/_portal/building/communication/new-article'
    | '/_portal/building/companies/$companyId'
    | '/_portal/building/settings/access'
    | '/_portal/building/settings/booking'
    | '/_portal/building/settings/communication'
    | '/_portal/building/settings/compliance'
    | '/_portal/building/settings/food'
    | '/_portal/building/settings/visit'
    | '/_portal/building/supersettings/card-migration'
    | '/_portal/company/$companyId/settings'
    | '/_portal/company/$companyId/subdivisions'
    | '/_portal/lunch-admin/deals/$companyId'
    | '/_portal/snack-admin/menu/categories'
    | '/_portal/snack-admin/orders/$orderId'
    | '/_portal/snack-admin/orders/new'
    | '/_portal/building/bookings/'
    | '/_portal/building/communication/'
    | '/_portal/building/companies/'
    | '/_portal/building/settings/'
    | '/_portal/building/supersettings/'
    | '/_portal/building/visitors/'
    | '/_portal/lunch-admin/deals/'
    | '/_portal/lunch-admin/insights/'
    | '/_portal/lunch-admin/overview/'
    | '/_portal/settings/consents/'
    | '/_portal/snack-admin/menu/'
    | '/_portal/snack-admin/orders/'
    | '/_portal/building/communication/$articleId/edit'
    | '/_portal/building/communication/new-notification/$articleId'
    | '/_portal/building/settings/room/create'
    | '/_portal/building/settings/template/$templateId'
    | '/_portal/building/settings/template/create'
    | '/_portal/building/visitors/preregistrations/new'
    | '/_portal/company/$companyId/bookings/new'
    | '/_portal/company/$companyId/users/$userId'
    | '/_portal/lunch-admin/overview/users/$userId'
    | '/_portal/snack-admin/menu/item/$itemId'
    | '/_portal/snack-admin/menu/item/new'
    | '/_portal/building/communication/$articleId/'
    | '/_portal/building/visitors/preregistrations/'
    | '/_portal/company/$companyId/bookings/'
    | '/_portal/company/$companyId/users/'
    | '/_portal/company/$companyId/visitors/'
    | '/_portal/lunch-admin/overview/users/'
    | '/_portal/building/settings/room/$roomId/edit'
    | '/_portal/company/$companyId/users/$userId/access'
    | '/_portal/company/$companyId/users/$userId/food'
    | '/_portal/company/$companyId/users/$userId/settings'
    | '/_portal/company/$companyId/visitors/preregistrations/new'
    | '/_portal/company/$companyId/visitors/preregistrations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  Building_overviewRouteRoute: typeof Building_overviewRouteRoute
  FoodLoginRoute: typeof FoodLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_portal': {
      id: '/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/building_overview': {
      id: '/building_overview'
      path: '/building_overview'
      fullPath: '/building_overview'
      preLoaderRoute: typeof Building_overviewRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/food-login': {
      id: '/food-login'
      path: '/food-login'
      fullPath: '/food-login'
      preLoaderRoute: typeof FoodLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal/': {
      id: '/_portal/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/401': {
      id: '/_portal/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof Portal401RouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/404': {
      id: '/_portal/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Portal404RouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/access': {
      id: '/_portal/access'
      path: '/access'
      fullPath: '/access'
      preLoaderRoute: typeof PortalAccessRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/handbook': {
      id: '/_portal/handbook'
      path: '/handbook'
      fullPath: '/handbook'
      preLoaderRoute: typeof PortalHandbookRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch': {
      id: '/_portal/lunch'
      path: '/lunch'
      fullPath: '/lunch'
      preLoaderRoute: typeof PortalLunchRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/bookings/': {
      id: '/_portal/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof PortalBookingsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/bookings/history': {
      id: '/_portal/bookings/history'
      path: '/bookings/history'
      fullPath: '/bookings/history'
      preLoaderRoute: typeof PortalBookingsHistoryRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/access': {
      id: '/_portal/building/access'
      path: '/building/access'
      fullPath: '/building/access'
      preLoaderRoute: typeof PortalBuildingAccessRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/access-role-management': {
      id: '/_portal/building/access-role-management'
      path: '/building/access-role-management'
      fullPath: '/building/access-role-management'
      preLoaderRoute: typeof PortalBuildingAccessRoleManagementRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/contact/$buildingId': {
      id: '/_portal/contact/$buildingId'
      path: '/contact/$buildingId'
      fullPath: '/contact/$buildingId'
      preLoaderRoute: typeof PortalContactBuildingIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/dashboard/': {
      id: '/_portal/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof PortalDashboardIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/food-admin/settings': {
      id: '/_portal/food-admin/settings'
      path: '/food-admin/settings'
      fullPath: '/food-admin/settings'
      preLoaderRoute: typeof PortalFoodAdminSettingsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/news/': {
      id: '/_portal/news/'
      path: '/news'
      fullPath: '/news/'
      preLoaderRoute: typeof PortalNewsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/news/$articleId': {
      id: '/_portal/news/$articleId'
      path: '/news/$articleId'
      fullPath: '/news/$articleId'
      preLoaderRoute: typeof PortalNewsArticleIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/orders/': {
      id: '/_portal/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof PortalOrdersIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/orders/$orderId': {
      id: '/_portal/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof PortalOrdersOrderIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/orders/new': {
      id: '/_portal/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof PortalOrdersNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/settings/': {
      id: '/_portal/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof PortalSettingsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/visitors/': {
      id: '/_portal/visitors/'
      path: '/visitors'
      fullPath: '/visitors/'
      preLoaderRoute: typeof PortalVisitorsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/visitors/preregistration': {
      id: '/_portal/visitors/preregistration'
      path: '/visitors/preregistration'
      fullPath: '/visitors/preregistration'
      preLoaderRoute: typeof PortalVisitorsPreregistrationRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/bookings/room/$roomId': {
      id: '/_portal/bookings/room/$roomId'
      path: '/bookings/room/$roomId'
      fullPath: '/bookings/room/$roomId'
      preLoaderRoute: typeof PortalBookingsRoomRoomIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/bookings/': {
      id: '/_portal/building/bookings/'
      path: '/building/bookings'
      fullPath: '/building/bookings/'
      preLoaderRoute: typeof PortalBuildingBookingsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/bookings/new': {
      id: '/_portal/building/bookings/new'
      path: '/building/bookings/new'
      fullPath: '/building/bookings/new'
      preLoaderRoute: typeof PortalBuildingBookingsNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/communication/': {
      id: '/_portal/building/communication/'
      path: '/building/communication'
      fullPath: '/building/communication/'
      preLoaderRoute: typeof PortalBuildingCommunicationIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/communication/new-article': {
      id: '/_portal/building/communication/new-article'
      path: '/building/communication/new-article'
      fullPath: '/building/communication/new-article'
      preLoaderRoute: typeof PortalBuildingCommunicationNewArticleRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/companies/': {
      id: '/_portal/building/companies/'
      path: '/building/companies'
      fullPath: '/building/companies/'
      preLoaderRoute: typeof PortalBuildingCompaniesIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/companies/$companyId': {
      id: '/_portal/building/companies/$companyId'
      path: '/building/companies/$companyId'
      fullPath: '/building/companies/$companyId'
      preLoaderRoute: typeof PortalBuildingCompaniesCompanyIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/': {
      id: '/_portal/building/settings/'
      path: '/building/settings'
      fullPath: '/building/settings/'
      preLoaderRoute: typeof PortalBuildingSettingsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/access': {
      id: '/_portal/building/settings/access'
      path: '/building/settings/access'
      fullPath: '/building/settings/access'
      preLoaderRoute: typeof PortalBuildingSettingsAccessRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/booking': {
      id: '/_portal/building/settings/booking'
      path: '/building/settings/booking'
      fullPath: '/building/settings/booking'
      preLoaderRoute: typeof PortalBuildingSettingsBookingRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/communication': {
      id: '/_portal/building/settings/communication'
      path: '/building/settings/communication'
      fullPath: '/building/settings/communication'
      preLoaderRoute: typeof PortalBuildingSettingsCommunicationRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/compliance': {
      id: '/_portal/building/settings/compliance'
      path: '/building/settings/compliance'
      fullPath: '/building/settings/compliance'
      preLoaderRoute: typeof PortalBuildingSettingsComplianceRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/food': {
      id: '/_portal/building/settings/food'
      path: '/building/settings/food'
      fullPath: '/building/settings/food'
      preLoaderRoute: typeof PortalBuildingSettingsFoodRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/visit': {
      id: '/_portal/building/settings/visit'
      path: '/building/settings/visit'
      fullPath: '/building/settings/visit'
      preLoaderRoute: typeof PortalBuildingSettingsVisitRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/supersettings/': {
      id: '/_portal/building/supersettings/'
      path: '/building/supersettings'
      fullPath: '/building/supersettings/'
      preLoaderRoute: typeof PortalBuildingSupersettingsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/supersettings/card-migration': {
      id: '/_portal/building/supersettings/card-migration'
      path: '/building/supersettings/card-migration'
      fullPath: '/building/supersettings/card-migration'
      preLoaderRoute: typeof PortalBuildingSupersettingsCardMigrationRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/visitors/': {
      id: '/_portal/building/visitors/'
      path: '/building/visitors'
      fullPath: '/building/visitors/'
      preLoaderRoute: typeof PortalBuildingVisitorsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/settings': {
      id: '/_portal/company/$companyId/settings'
      path: '/company/$companyId/settings'
      fullPath: '/company/$companyId/settings'
      preLoaderRoute: typeof PortalCompanyCompanyIdSettingsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/subdivisions': {
      id: '/_portal/company/$companyId/subdivisions'
      path: '/company/$companyId/subdivisions'
      fullPath: '/company/$companyId/subdivisions'
      preLoaderRoute: typeof PortalCompanyCompanyIdSubdivisionsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch-admin/deals/': {
      id: '/_portal/lunch-admin/deals/'
      path: '/lunch-admin/deals'
      fullPath: '/lunch-admin/deals/'
      preLoaderRoute: typeof PortalLunchAdminDealsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch-admin/deals/$companyId': {
      id: '/_portal/lunch-admin/deals/$companyId'
      path: '/lunch-admin/deals/$companyId'
      fullPath: '/lunch-admin/deals/$companyId'
      preLoaderRoute: typeof PortalLunchAdminDealsCompanyIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch-admin/insights/': {
      id: '/_portal/lunch-admin/insights/'
      path: '/lunch-admin/insights'
      fullPath: '/lunch-admin/insights/'
      preLoaderRoute: typeof PortalLunchAdminInsightsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch-admin/overview/': {
      id: '/_portal/lunch-admin/overview/'
      path: '/lunch-admin/overview'
      fullPath: '/lunch-admin/overview/'
      preLoaderRoute: typeof PortalLunchAdminOverviewIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/settings/consents/': {
      id: '/_portal/settings/consents/'
      path: '/settings/consents'
      fullPath: '/settings/consents/'
      preLoaderRoute: typeof PortalSettingsConsentsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/menu/': {
      id: '/_portal/snack-admin/menu/'
      path: '/snack-admin/menu'
      fullPath: '/snack-admin/menu/'
      preLoaderRoute: typeof PortalSnackAdminMenuIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/menu/categories': {
      id: '/_portal/snack-admin/menu/categories'
      path: '/snack-admin/menu/categories'
      fullPath: '/snack-admin/menu/categories'
      preLoaderRoute: typeof PortalSnackAdminMenuCategoriesRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/orders/': {
      id: '/_portal/snack-admin/orders/'
      path: '/snack-admin/orders'
      fullPath: '/snack-admin/orders/'
      preLoaderRoute: typeof PortalSnackAdminOrdersIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/orders/$orderId': {
      id: '/_portal/snack-admin/orders/$orderId'
      path: '/snack-admin/orders/$orderId'
      fullPath: '/snack-admin/orders/$orderId'
      preLoaderRoute: typeof PortalSnackAdminOrdersOrderIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/orders/new': {
      id: '/_portal/snack-admin/orders/new'
      path: '/snack-admin/orders/new'
      fullPath: '/snack-admin/orders/new'
      preLoaderRoute: typeof PortalSnackAdminOrdersNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/communication/$articleId/': {
      id: '/_portal/building/communication/$articleId/'
      path: '/building/communication/$articleId'
      fullPath: '/building/communication/$articleId/'
      preLoaderRoute: typeof PortalBuildingCommunicationArticleIdIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/communication/$articleId/edit': {
      id: '/_portal/building/communication/$articleId/edit'
      path: '/building/communication/$articleId/edit'
      fullPath: '/building/communication/$articleId/edit'
      preLoaderRoute: typeof PortalBuildingCommunicationArticleIdEditRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/communication/new-notification/$articleId': {
      id: '/_portal/building/communication/new-notification/$articleId'
      path: '/building/communication/new-notification/$articleId'
      fullPath: '/building/communication/new-notification/$articleId'
      preLoaderRoute: typeof PortalBuildingCommunicationNewNotificationArticleIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/room/create': {
      id: '/_portal/building/settings/room/create'
      path: '/building/settings/room/create'
      fullPath: '/building/settings/room/create'
      preLoaderRoute: typeof PortalBuildingSettingsRoomCreateRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/template/$templateId': {
      id: '/_portal/building/settings/template/$templateId'
      path: '/building/settings/template/$templateId'
      fullPath: '/building/settings/template/$templateId'
      preLoaderRoute: typeof PortalBuildingSettingsTemplateTemplateIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/template/create': {
      id: '/_portal/building/settings/template/create'
      path: '/building/settings/template/create'
      fullPath: '/building/settings/template/create'
      preLoaderRoute: typeof PortalBuildingSettingsTemplateCreateRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/visitors/preregistrations/': {
      id: '/_portal/building/visitors/preregistrations/'
      path: '/building/visitors/preregistrations'
      fullPath: '/building/visitors/preregistrations/'
      preLoaderRoute: typeof PortalBuildingVisitorsPreregistrationsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/visitors/preregistrations/new': {
      id: '/_portal/building/visitors/preregistrations/new'
      path: '/building/visitors/preregistrations/new'
      fullPath: '/building/visitors/preregistrations/new'
      preLoaderRoute: typeof PortalBuildingVisitorsPreregistrationsNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/bookings/': {
      id: '/_portal/company/$companyId/bookings/'
      path: '/company/$companyId/bookings'
      fullPath: '/company/$companyId/bookings/'
      preLoaderRoute: typeof PortalCompanyCompanyIdBookingsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/bookings/new': {
      id: '/_portal/company/$companyId/bookings/new'
      path: '/company/$companyId/bookings/new'
      fullPath: '/company/$companyId/bookings/new'
      preLoaderRoute: typeof PortalCompanyCompanyIdBookingsNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/users/': {
      id: '/_portal/company/$companyId/users/'
      path: '/company/$companyId/users'
      fullPath: '/company/$companyId/users/'
      preLoaderRoute: typeof PortalCompanyCompanyIdUsersIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/users/$userId': {
      id: '/_portal/company/$companyId/users/$userId'
      path: '/company/$companyId/users/$userId'
      fullPath: '/company/$companyId/users/$userId'
      preLoaderRoute: typeof PortalCompanyCompanyIdUsersUserIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/visitors/': {
      id: '/_portal/company/$companyId/visitors/'
      path: '/company/$companyId/visitors'
      fullPath: '/company/$companyId/visitors/'
      preLoaderRoute: typeof PortalCompanyCompanyIdVisitorsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch-admin/overview/users/': {
      id: '/_portal/lunch-admin/overview/users/'
      path: '/lunch-admin/overview/users'
      fullPath: '/lunch-admin/overview/users/'
      preLoaderRoute: typeof PortalLunchAdminOverviewUsersIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/lunch-admin/overview/users/$userId': {
      id: '/_portal/lunch-admin/overview/users/$userId'
      path: '/lunch-admin/overview/users/$userId'
      fullPath: '/lunch-admin/overview/users/$userId'
      preLoaderRoute: typeof PortalLunchAdminOverviewUsersUserIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/menu/item/$itemId': {
      id: '/_portal/snack-admin/menu/item/$itemId'
      path: '/snack-admin/menu/item/$itemId'
      fullPath: '/snack-admin/menu/item/$itemId'
      preLoaderRoute: typeof PortalSnackAdminMenuItemItemIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/snack-admin/menu/item/new': {
      id: '/_portal/snack-admin/menu/item/new'
      path: '/snack-admin/menu/item/new'
      fullPath: '/snack-admin/menu/item/new'
      preLoaderRoute: typeof PortalSnackAdminMenuItemNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/building/settings/room/$roomId/edit': {
      id: '/_portal/building/settings/room/$roomId/edit'
      path: '/building/settings/room/$roomId/edit'
      fullPath: '/building/settings/room/$roomId/edit'
      preLoaderRoute: typeof PortalBuildingSettingsRoomRoomIdEditRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/users/$userId/access': {
      id: '/_portal/company/$companyId/users/$userId/access'
      path: '/access'
      fullPath: '/company/$companyId/users/$userId/access'
      preLoaderRoute: typeof PortalCompanyCompanyIdUsersUserIdAccessRouteImport
      parentRoute: typeof PortalCompanyCompanyIdUsersUserIdRoute
    }
    '/_portal/company/$companyId/users/$userId/food': {
      id: '/_portal/company/$companyId/users/$userId/food'
      path: '/food'
      fullPath: '/company/$companyId/users/$userId/food'
      preLoaderRoute: typeof PortalCompanyCompanyIdUsersUserIdFoodRouteImport
      parentRoute: typeof PortalCompanyCompanyIdUsersUserIdRoute
    }
    '/_portal/company/$companyId/users/$userId/settings': {
      id: '/_portal/company/$companyId/users/$userId/settings'
      path: '/settings'
      fullPath: '/company/$companyId/users/$userId/settings'
      preLoaderRoute: typeof PortalCompanyCompanyIdUsersUserIdSettingsRouteImport
      parentRoute: typeof PortalCompanyCompanyIdUsersUserIdRoute
    }
    '/_portal/company/$companyId/visitors/preregistrations/': {
      id: '/_portal/company/$companyId/visitors/preregistrations/'
      path: '/company/$companyId/visitors/preregistrations'
      fullPath: '/company/$companyId/visitors/preregistrations/'
      preLoaderRoute: typeof PortalCompanyCompanyIdVisitorsPreregistrationsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_portal/company/$companyId/visitors/preregistrations/new': {
      id: '/_portal/company/$companyId/visitors/preregistrations/new'
      path: '/company/$companyId/visitors/preregistrations/new'
      fullPath: '/company/$companyId/visitors/preregistrations/new'
      preLoaderRoute: typeof PortalCompanyCompanyIdVisitorsPreregistrationsNewRouteImport
      parentRoute: typeof PortalRouteRoute
    }
  }
}

interface PortalCompanyCompanyIdUsersUserIdRouteChildren {
  PortalCompanyCompanyIdUsersUserIdAccessRoute: typeof PortalCompanyCompanyIdUsersUserIdAccessRoute
  PortalCompanyCompanyIdUsersUserIdFoodRoute: typeof PortalCompanyCompanyIdUsersUserIdFoodRoute
  PortalCompanyCompanyIdUsersUserIdSettingsRoute: typeof PortalCompanyCompanyIdUsersUserIdSettingsRoute
}

const PortalCompanyCompanyIdUsersUserIdRouteChildren: PortalCompanyCompanyIdUsersUserIdRouteChildren =
  {
    PortalCompanyCompanyIdUsersUserIdAccessRoute:
      PortalCompanyCompanyIdUsersUserIdAccessRoute,
    PortalCompanyCompanyIdUsersUserIdFoodRoute:
      PortalCompanyCompanyIdUsersUserIdFoodRoute,
    PortalCompanyCompanyIdUsersUserIdSettingsRoute:
      PortalCompanyCompanyIdUsersUserIdSettingsRoute,
  }

const PortalCompanyCompanyIdUsersUserIdRouteWithChildren =
  PortalCompanyCompanyIdUsersUserIdRoute._addFileChildren(
    PortalCompanyCompanyIdUsersUserIdRouteChildren,
  )

interface PortalRouteRouteChildren {
  Portal401Route: typeof Portal401Route
  Portal404Route: typeof Portal404Route
  PortalAccessRoute: typeof PortalAccessRoute
  PortalHandbookRoute: typeof PortalHandbookRoute
  PortalLunchRoute: typeof PortalLunchRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalBookingsHistoryRoute: typeof PortalBookingsHistoryRoute
  PortalBuildingAccessRoute: typeof PortalBuildingAccessRoute
  PortalBuildingAccessRoleManagementRoute: typeof PortalBuildingAccessRoleManagementRoute
  PortalContactBuildingIdRoute: typeof PortalContactBuildingIdRoute
  PortalFoodAdminSettingsRoute: typeof PortalFoodAdminSettingsRoute
  PortalNewsArticleIdRoute: typeof PortalNewsArticleIdRoute
  PortalOrdersOrderIdRoute: typeof PortalOrdersOrderIdRoute
  PortalOrdersNewRoute: typeof PortalOrdersNewRoute
  PortalVisitorsPreregistrationRoute: typeof PortalVisitorsPreregistrationRoute
  PortalBookingsIndexRoute: typeof PortalBookingsIndexRoute
  PortalDashboardIndexRoute: typeof PortalDashboardIndexRoute
  PortalNewsIndexRoute: typeof PortalNewsIndexRoute
  PortalOrdersIndexRoute: typeof PortalOrdersIndexRoute
  PortalSettingsIndexRoute: typeof PortalSettingsIndexRoute
  PortalVisitorsIndexRoute: typeof PortalVisitorsIndexRoute
  PortalBookingsRoomRoomIdRoute: typeof PortalBookingsRoomRoomIdRoute
  PortalBuildingBookingsNewRoute: typeof PortalBuildingBookingsNewRoute
  PortalBuildingCommunicationNewArticleRoute: typeof PortalBuildingCommunicationNewArticleRoute
  PortalBuildingCompaniesCompanyIdRoute: typeof PortalBuildingCompaniesCompanyIdRoute
  PortalBuildingSettingsAccessRoute: typeof PortalBuildingSettingsAccessRoute
  PortalBuildingSettingsBookingRoute: typeof PortalBuildingSettingsBookingRoute
  PortalBuildingSettingsCommunicationRoute: typeof PortalBuildingSettingsCommunicationRoute
  PortalBuildingSettingsComplianceRoute: typeof PortalBuildingSettingsComplianceRoute
  PortalBuildingSettingsFoodRoute: typeof PortalBuildingSettingsFoodRoute
  PortalBuildingSettingsVisitRoute: typeof PortalBuildingSettingsVisitRoute
  PortalBuildingSupersettingsCardMigrationRoute: typeof PortalBuildingSupersettingsCardMigrationRoute
  PortalCompanyCompanyIdSettingsRoute: typeof PortalCompanyCompanyIdSettingsRoute
  PortalCompanyCompanyIdSubdivisionsRoute: typeof PortalCompanyCompanyIdSubdivisionsRoute
  PortalLunchAdminDealsCompanyIdRoute: typeof PortalLunchAdminDealsCompanyIdRoute
  PortalSnackAdminMenuCategoriesRoute: typeof PortalSnackAdminMenuCategoriesRoute
  PortalSnackAdminOrdersOrderIdRoute: typeof PortalSnackAdminOrdersOrderIdRoute
  PortalSnackAdminOrdersNewRoute: typeof PortalSnackAdminOrdersNewRoute
  PortalBuildingBookingsIndexRoute: typeof PortalBuildingBookingsIndexRoute
  PortalBuildingCommunicationIndexRoute: typeof PortalBuildingCommunicationIndexRoute
  PortalBuildingCompaniesIndexRoute: typeof PortalBuildingCompaniesIndexRoute
  PortalBuildingSettingsIndexRoute: typeof PortalBuildingSettingsIndexRoute
  PortalBuildingSupersettingsIndexRoute: typeof PortalBuildingSupersettingsIndexRoute
  PortalBuildingVisitorsIndexRoute: typeof PortalBuildingVisitorsIndexRoute
  PortalLunchAdminDealsIndexRoute: typeof PortalLunchAdminDealsIndexRoute
  PortalLunchAdminInsightsIndexRoute: typeof PortalLunchAdminInsightsIndexRoute
  PortalLunchAdminOverviewIndexRoute: typeof PortalLunchAdminOverviewIndexRoute
  PortalSettingsConsentsIndexRoute: typeof PortalSettingsConsentsIndexRoute
  PortalSnackAdminMenuIndexRoute: typeof PortalSnackAdminMenuIndexRoute
  PortalSnackAdminOrdersIndexRoute: typeof PortalSnackAdminOrdersIndexRoute
  PortalBuildingCommunicationArticleIdEditRoute: typeof PortalBuildingCommunicationArticleIdEditRoute
  PortalBuildingCommunicationNewNotificationArticleIdRoute: typeof PortalBuildingCommunicationNewNotificationArticleIdRoute
  PortalBuildingSettingsRoomCreateRoute: typeof PortalBuildingSettingsRoomCreateRoute
  PortalBuildingSettingsTemplateTemplateIdRoute: typeof PortalBuildingSettingsTemplateTemplateIdRoute
  PortalBuildingSettingsTemplateCreateRoute: typeof PortalBuildingSettingsTemplateCreateRoute
  PortalBuildingVisitorsPreregistrationsNewRoute: typeof PortalBuildingVisitorsPreregistrationsNewRoute
  PortalCompanyCompanyIdBookingsNewRoute: typeof PortalCompanyCompanyIdBookingsNewRoute
  PortalCompanyCompanyIdUsersUserIdRoute: typeof PortalCompanyCompanyIdUsersUserIdRouteWithChildren
  PortalLunchAdminOverviewUsersUserIdRoute: typeof PortalLunchAdminOverviewUsersUserIdRoute
  PortalSnackAdminMenuItemItemIdRoute: typeof PortalSnackAdminMenuItemItemIdRoute
  PortalSnackAdminMenuItemNewRoute: typeof PortalSnackAdminMenuItemNewRoute
  PortalBuildingCommunicationArticleIdIndexRoute: typeof PortalBuildingCommunicationArticleIdIndexRoute
  PortalBuildingVisitorsPreregistrationsIndexRoute: typeof PortalBuildingVisitorsPreregistrationsIndexRoute
  PortalCompanyCompanyIdBookingsIndexRoute: typeof PortalCompanyCompanyIdBookingsIndexRoute
  PortalCompanyCompanyIdUsersIndexRoute: typeof PortalCompanyCompanyIdUsersIndexRoute
  PortalCompanyCompanyIdVisitorsIndexRoute: typeof PortalCompanyCompanyIdVisitorsIndexRoute
  PortalLunchAdminOverviewUsersIndexRoute: typeof PortalLunchAdminOverviewUsersIndexRoute
  PortalBuildingSettingsRoomRoomIdEditRoute: typeof PortalBuildingSettingsRoomRoomIdEditRoute
  PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute: typeof PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute
  PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute: typeof PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  Portal401Route: Portal401Route,
  Portal404Route: Portal404Route,
  PortalAccessRoute: PortalAccessRoute,
  PortalHandbookRoute: PortalHandbookRoute,
  PortalLunchRoute: PortalLunchRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalBookingsHistoryRoute: PortalBookingsHistoryRoute,
  PortalBuildingAccessRoute: PortalBuildingAccessRoute,
  PortalBuildingAccessRoleManagementRoute:
    PortalBuildingAccessRoleManagementRoute,
  PortalContactBuildingIdRoute: PortalContactBuildingIdRoute,
  PortalFoodAdminSettingsRoute: PortalFoodAdminSettingsRoute,
  PortalNewsArticleIdRoute: PortalNewsArticleIdRoute,
  PortalOrdersOrderIdRoute: PortalOrdersOrderIdRoute,
  PortalOrdersNewRoute: PortalOrdersNewRoute,
  PortalVisitorsPreregistrationRoute: PortalVisitorsPreregistrationRoute,
  PortalBookingsIndexRoute: PortalBookingsIndexRoute,
  PortalDashboardIndexRoute: PortalDashboardIndexRoute,
  PortalNewsIndexRoute: PortalNewsIndexRoute,
  PortalOrdersIndexRoute: PortalOrdersIndexRoute,
  PortalSettingsIndexRoute: PortalSettingsIndexRoute,
  PortalVisitorsIndexRoute: PortalVisitorsIndexRoute,
  PortalBookingsRoomRoomIdRoute: PortalBookingsRoomRoomIdRoute,
  PortalBuildingBookingsNewRoute: PortalBuildingBookingsNewRoute,
  PortalBuildingCommunicationNewArticleRoute:
    PortalBuildingCommunicationNewArticleRoute,
  PortalBuildingCompaniesCompanyIdRoute: PortalBuildingCompaniesCompanyIdRoute,
  PortalBuildingSettingsAccessRoute: PortalBuildingSettingsAccessRoute,
  PortalBuildingSettingsBookingRoute: PortalBuildingSettingsBookingRoute,
  PortalBuildingSettingsCommunicationRoute:
    PortalBuildingSettingsCommunicationRoute,
  PortalBuildingSettingsComplianceRoute: PortalBuildingSettingsComplianceRoute,
  PortalBuildingSettingsFoodRoute: PortalBuildingSettingsFoodRoute,
  PortalBuildingSettingsVisitRoute: PortalBuildingSettingsVisitRoute,
  PortalBuildingSupersettingsCardMigrationRoute:
    PortalBuildingSupersettingsCardMigrationRoute,
  PortalCompanyCompanyIdSettingsRoute: PortalCompanyCompanyIdSettingsRoute,
  PortalCompanyCompanyIdSubdivisionsRoute:
    PortalCompanyCompanyIdSubdivisionsRoute,
  PortalLunchAdminDealsCompanyIdRoute: PortalLunchAdminDealsCompanyIdRoute,
  PortalSnackAdminMenuCategoriesRoute: PortalSnackAdminMenuCategoriesRoute,
  PortalSnackAdminOrdersOrderIdRoute: PortalSnackAdminOrdersOrderIdRoute,
  PortalSnackAdminOrdersNewRoute: PortalSnackAdminOrdersNewRoute,
  PortalBuildingBookingsIndexRoute: PortalBuildingBookingsIndexRoute,
  PortalBuildingCommunicationIndexRoute: PortalBuildingCommunicationIndexRoute,
  PortalBuildingCompaniesIndexRoute: PortalBuildingCompaniesIndexRoute,
  PortalBuildingSettingsIndexRoute: PortalBuildingSettingsIndexRoute,
  PortalBuildingSupersettingsIndexRoute: PortalBuildingSupersettingsIndexRoute,
  PortalBuildingVisitorsIndexRoute: PortalBuildingVisitorsIndexRoute,
  PortalLunchAdminDealsIndexRoute: PortalLunchAdminDealsIndexRoute,
  PortalLunchAdminInsightsIndexRoute: PortalLunchAdminInsightsIndexRoute,
  PortalLunchAdminOverviewIndexRoute: PortalLunchAdminOverviewIndexRoute,
  PortalSettingsConsentsIndexRoute: PortalSettingsConsentsIndexRoute,
  PortalSnackAdminMenuIndexRoute: PortalSnackAdminMenuIndexRoute,
  PortalSnackAdminOrdersIndexRoute: PortalSnackAdminOrdersIndexRoute,
  PortalBuildingCommunicationArticleIdEditRoute:
    PortalBuildingCommunicationArticleIdEditRoute,
  PortalBuildingCommunicationNewNotificationArticleIdRoute:
    PortalBuildingCommunicationNewNotificationArticleIdRoute,
  PortalBuildingSettingsRoomCreateRoute: PortalBuildingSettingsRoomCreateRoute,
  PortalBuildingSettingsTemplateTemplateIdRoute:
    PortalBuildingSettingsTemplateTemplateIdRoute,
  PortalBuildingSettingsTemplateCreateRoute:
    PortalBuildingSettingsTemplateCreateRoute,
  PortalBuildingVisitorsPreregistrationsNewRoute:
    PortalBuildingVisitorsPreregistrationsNewRoute,
  PortalCompanyCompanyIdBookingsNewRoute:
    PortalCompanyCompanyIdBookingsNewRoute,
  PortalCompanyCompanyIdUsersUserIdRoute:
    PortalCompanyCompanyIdUsersUserIdRouteWithChildren,
  PortalLunchAdminOverviewUsersUserIdRoute:
    PortalLunchAdminOverviewUsersUserIdRoute,
  PortalSnackAdminMenuItemItemIdRoute: PortalSnackAdminMenuItemItemIdRoute,
  PortalSnackAdminMenuItemNewRoute: PortalSnackAdminMenuItemNewRoute,
  PortalBuildingCommunicationArticleIdIndexRoute:
    PortalBuildingCommunicationArticleIdIndexRoute,
  PortalBuildingVisitorsPreregistrationsIndexRoute:
    PortalBuildingVisitorsPreregistrationsIndexRoute,
  PortalCompanyCompanyIdBookingsIndexRoute:
    PortalCompanyCompanyIdBookingsIndexRoute,
  PortalCompanyCompanyIdUsersIndexRoute: PortalCompanyCompanyIdUsersIndexRoute,
  PortalCompanyCompanyIdVisitorsIndexRoute:
    PortalCompanyCompanyIdVisitorsIndexRoute,
  PortalLunchAdminOverviewUsersIndexRoute:
    PortalLunchAdminOverviewUsersIndexRoute,
  PortalBuildingSettingsRoomRoomIdEditRoute:
    PortalBuildingSettingsRoomRoomIdEditRoute,
  PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute:
    PortalCompanyCompanyIdVisitorsPreregistrationsNewRoute,
  PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute:
    PortalCompanyCompanyIdVisitorsPreregistrationsIndexRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PortalRouteRoute: PortalRouteRouteWithChildren,
  Building_overviewRouteRoute: Building_overviewRouteRoute,
  FoodLoginRoute: FoodLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
